import CONFIG from 'src/utils/config';
import DashboardPage from './Dashboard';
import { AppBrands } from 'src/utils/constants';
import DashboardSimple from './DashboardSimple';

export const DashboardWrapper = () => {
    const isQwic = CONFIG.APP_BRAND === AppBrands.QWIC;

    if (isQwic) {
        return <DashboardPage />;
    }

    return <DashboardSimple />;
};
